import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, sempre obrigatório
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Tema de CSS com estilo pré-definido
import { useEffect, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDown, faCircleUp, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import styles from './ListaEquipamento.module.css';
import servSolicitacaoAcesso from '../../services/login/servSolicitacaoAcesso';
import { Tooltip } from '@mui/material';
import Popup from '../Popup';
import StatusEquipamento from '../StatusEquipamento';
import Cadastro from '../../pages/Equipamentos/Cadastro';
import { AG_GRID_LOCALE_PT_BR } from '../ListaParticipante/AgGridPTBR';

// #region Remover equipamento
const RemoverEquipamento = ({row, setRowData, setIsLoading}) => {
    return (
        <button className={styles.listaParcipantesDelete} id="removerEquipamento" onClick={() => onClickRemoverEquipamento(row, setRowData, setIsLoading)}>
            <FontAwesomeIcon icon={faTrash} />
        </button>
    )
}

const onClickRemoverEquipamento = async (row, setRowData, setIsLoading) => {
    
    let data = row.data;
    let setEquips = data.setEquips;
    let setEquipsWF = data.setEquipsFunctions;
    
    try {
        setIsLoading(true);

        const response = await servSolicitacaoAcesso.RemoverEquipamentoDaSolicitacao(data.Id);  
        
        let conteudo = response.Content;

        conteudo = conteudo.map(equip => {
            equip.id = equip.Id;
            return equip
        })

        const formattedRowsWFunction = conteudo.map(element => {
            return {
                ...element,
                setEquips: setEquips,
                setEquipsFunctions: setEquipsWF
            }
        });

        setIsLoading(false);

        setEquips(conteudo);
        setEquipsWF(formattedRowsWFunction);
        setRowData(formattedRowsWFunction);
    } catch (err) {
        setIsLoading(false);
        console.log(err);
    }
}
// #endregion

// #region Editar/visualizar equipamento
const EditarVisualizarEquipamento = ({row}) => {
    const [openPopup, setOpenPopup] = useState(false);
    const [equipamento, setEquipamento] = useState(null);

    const handleEditarVisualizarEquipamento = () => {
        if(row.data && row.data.Equipamento) {
            setEquipamento(row.data.Equipamento);
            setOpenPopup(true);
        }
    }

    return (
        <>
            <button onClick={handleEditarVisualizarEquipamento} className={styles.listaEquipsVisualizar} id="visualizarEquipamento">
                <FontAwesomeIcon icon={faSearch} />
            </button>
            <Popup title="Equipamentos" openPopup={openPopup} setOpenPopup={setOpenPopup}>
                <Cadastro 
                    setOpenPopup={setOpenPopup} 
                    recordForEdit={equipamento}
                    origemSolicitacao={true}
                    origemListaEquipamentosSolicitacao={true}
                />
            </Popup>
        </>
    )
}
// #endregion

const ListaEquipamento = ({ equipamentos, setIsLoading }) => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const initialColumnDef = [
        { field: 'EditarVisualizar', headerName: '', minWidth: 68, flex: 0.68, sortable: false, filter: false,
            cellRenderer: (row) => <EditarVisualizarEquipamento row={row} />,
        },
        { field: 'Equipamento.Situacao', headerName: 'Situação', minWidth: 90, flex: 0.9, sortable: false, filter: false, cellRenderer: (row) => <div style={{ marginTop: "5px" }}><StatusEquipamento value={row.data.Equipamento.Situacao} /></div> },
        { field: 'CodigoEquipamento', headerName: 'Equip.', minWidth: 90.5, flex: 0.905 },
        { field: 'Equipamento.Descricao', headerName: 'Nome', minWidth: 105, flex: 1.05, cellRenderer: (row) => (
            <Tooltip style={{ marginTop:"-2px" }} title={ row.data.Equipamento.Descricao } placement="bottom">
                <p>{ row.data.Equipamento.Descricao }</p>
            </Tooltip>
        ) },
        { field: 'Quantidade', headerName: 'Qtde', minWidth: 85, flex: 0.85 },
        { field: 'PotenciaEquipamento', headerName: 'Potência un. (kW)', headerTooltip: 'Potência un. (kW)', minWidth: 95, flex: 0.95, cellRenderer: (row) => row.data.PotenciaEquipamento.toLocaleString() },
        { field: 'PotenciaTotal', headerName: 'Potência total (kW)', headerTooltip: 'Potência total (kW)', minWidth: 95, flex: 0.95, cellRenderer: (row) => row.data.PotenciaTotal.toLocaleString() },
        { field: 'Remover', headerName: 'Remover', minWidth: 90, flex: 0.9, sortable: false, filter: false, cellRenderer: (row) => <RemoverEquipamento row={row} setRowData={setRowData} setIsLoading={setIsLoading}/> }
    ];
    const [columnDefs, setColumnDefs] = useState(initialColumnDef);
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        headerClass: "ag-left-aligned-header",
        resizable: true,
        cellStyle: { border: 'none' }
    }), []);
    const localeText = useMemo(() => {
        return AG_GRID_LOCALE_PT_BR;
    }, []);

    useEffect(() => {
        setRowData(equipamentos);
        setColumnDefs(initialColumnDef);
    }, [equipamentos]);
    
    return (
        <>
            <div className="ag-theme-alpine-dark" style={{ minHeight: 150, height: 200, maxHeight: 350 }}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    rowHeight={40}
                    headerHeight={50}
                    defaultColDef={defaultColDef}
                    localeText={localeText}
                />
            </div>
        </>
        
    );
}

export { ListaEquipamento }